module.exports = __webpack_public_path__ + "img/album05_05.a5030dd4.jpg";